/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_LimitationsInputs */

const en_directory_agent_readiness_limitations = /** @type {(inputs: Directory_Agent_Readiness_LimitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where agents are blocked`)
};

const zh_directory_agent_readiness_limitations = /** @type {(inputs: Directory_Agent_Readiness_LimitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 受阻的部分`)
};

/**
* | output |
* | --- |
* | "Where agents are blocked" |
*
* @param {Directory_Agent_Readiness_LimitationsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_limitations = /** @type {((inputs?: Directory_Agent_Readiness_LimitationsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_LimitationsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_limitations(inputs)
	return zh_directory_agent_readiness_limitations(inputs)
});
export { directory_agent_readiness_limitations as "directory.agent_readiness.limitations" }